import React, { useContext } from 'react';
import { ReferenceIdTextInput } from './ReferenceIdTextInput';
import { Column, Row } from '../Layout';
import { PaymentContext } from '../PaymentContext';

const ReferralCredit = ({ transaction, setTransaction }) => {
  // Obtain invoiceSummary from context
  const { invoiceSummary } = useContext(PaymentContext);

  return (
    <Row>
      <Column>
        
        <span className="heavy">Available Credits to apply to Study:</span> {invoiceSummary.availableCredits}
        
        <input type="hidden" value={invoiceSummary.availableCredits} />
        
        <ReferenceIdTextInput transaction={transaction} setTransaction={setTransaction} />
      </Column>
    </Row>
  );
};

export default ReferralCredit;
